shvenergy.mobilemenu = (function ($) {
	"use strict";

	var mobileMenu = $(".mobile-menu");
	var initialClasses = mobileMenu.attr("class");

	var subMenuButtons = mobileMenu.find("[data-submenu]");
	var selectedItems = mobileMenu.find(".is-selected");

	var ctaColumn = $("[data-ctacolumn]"); //This is where we want to inject selected CTA's
	var ctaContainer = $(".cta-container"); //This is where CTA's are stored. We get them all at once from the server
	var rootCta = $("[data-main-cta]"); 
	let canvasFooterScroll = $(".offcanvasmenu__footer .scroll-column");
	let canvasFooter = $(".offcanvasmenu__footer");
	let flag = true; 

	function addMobileClasses() {
		mobileMenu.attr("class", initialClasses);

		if (window.SHVMobileClasses && typeof window.SHVMobileClasses === "string") {

			var x = window.SHVMobileClasses.split(' ');
			mobileMenu.addClass(x.join(' '));
		}
	}

	function resetMobileMenuClasses() {
		mobileMenu.attr("class", initialClasses);
		subMenuButtons.removeClass("active");
	}

	function closeOffCanvasMenu() {
		$("html").removeClass("offcanvasmenu-active");

		setTimeout(function () {
			$(".offcanvasmenu").removeClass("offcanvasmenu-visible");
			resetMobileMenuClasses();
			mobileMenu.removeClass("lvl1active").removeClass("lvl2active").removeClass("lvl3active").removeClass("lvl4active");
		}, 310); //css animation time + 10 ms
	}

	function populateCtaColumn(...ctas) {
		// Delay added to fix problem when using navigation on subpages (User Story 8319)
		// This could/should probably be fixed in another way
		setTimeout(function () {
			ctaColumn.empty();
			ctas.forEach(cta => {
				if (cta) {
					ctaColumn.append();
					ctaColumn.append(cta.clone(true));
					if (cta.attr("data-ctaid")) {
						if (flag) {
							canvasFooterScroll.addClass("data-cta-active");
							flag = false;
						}
						updateCtaLink("", cta.attr("data-ctaid"));
					}
				}
			})
		}, 1)
	}

	function findInCtaContainer(ctaId) {
		if (!ctaId) return null;
		return ctaContainer.find(`[data-ctaid=${ctaId}]`);
	}

	function updateCtaLink(lvl, ctaId) {
		if (lvl === 1 || lvl === "1") {
			canvasFooterScroll.removeClass("data-cta-active");
			canvasFooter.removeClass("active");
		} else {
			canvasFooter.addClass("active");
			canvasFooterScroll.find("[data-ctaid=" + ctaId + "]").find("[class=" + "large-icon__wrapper" + "]").addClass("active");
			canvasFooterScroll.find("[data-ctaid=" + ctaId + "]").find("a").addClass("active");
		}
	}

	function init() {
		$(".offcanvas-menu-button").on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			updateCtaLink(1, "");

			if ($("html").hasClass("offcanvasmenu-active")) {
				closeOffCanvasMenu();
			} else {
				ctaColumn.empty();

				populateCtaColumn(rootCta);

				$(".offcanvasmenu").addClass("offcanvasmenu-visible");
				setTimeout(function () {
					$("html").addClass("offcanvasmenu-active");
				}, 20);
			}

		});

		$(document).on("keyup", function (e) {
			if (e.which === 27) {
				closeOffCanvasMenu();
			}
		});

		$(document).on("click", function (e) {

			if ($(e.target).closest(".offcanvasmenu").length === 0) {
				closeOffCanvasMenu();
			}
		});

		$("button[data-submenu]").on("click", function () {
			flag = true;
			var lvl = $(this).data("submenu");
			var currentLvl = lvl + "active";

			var cta1 = findInCtaContainer($(this).data("ctaidone"));
			var cta2 = findInCtaContainer($(this).data("ctaidtwo"));
			populateCtaColumn(
				cta1,
				cta2
			);

			mobileMenu.addClass(currentLvl);

			$(this).addClass("active");
		});

		$("button[data-back]").on("click", function () {
			var button = $(this);
			var lvl = button.data("back");
			var i = lvl.replace("lvl", ""); //gets the level as number

			if (i === 1 || i === "1") {
				populateCtaColumn(rootCta);
				updateCtaLink(i, "");
			} else {
				var cta1 = findInCtaContainer($(this).data("ctaidone"));
				var cta2 = findInCtaContainer($(this).data("ctaidtwo"));
				populateCtaColumn(
					cta1,
					cta2
				);
			}

			if (i) {
				var previousIndex = Number(i) + 1;

				mobileMenu.removeClass(`lvl${previousIndex}active`);
				mobileMenu.find(`[data-submenu='lvl${previousIndex}']`).removeClass("active");
			}
		});

		//Servicemenu stuff and login logic
		$("#showMobileLoginOptions").on("click", function () {
			$(".mobile-login").show();
			$(this).attr("aria-expanded", "true");
		});

		$("#hideMobileLoginOptions").on("click", function () {
			$(".mobile-login").hide();
			$("#showMobileLoginOptions").attr("aria-expanded", "false");
		});
	}

	init();

})(jQuery);
